<template>
  <div>
    <h1>Overall customer stock worth</h1>
    <v-row class="pa-5">
      <v-col
        cols="12"
        md="12"
      >
        <v-switch v-model="switch1" />
        <template v-if="switch1">
          <line-chart
            :data="barChart"
            :download="{ background: '#fff' }"
          />
        </template>
        <template v-else>
          <bar-chart
            :data="barChart"
            :colors="['#fb8c00bf']"
            :download="{ background: '#fff' }"
          />
        </template>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <pie-chart
          :donut="true"
          :download="{ background: '#fff' }"
          :colors="['red', 'green']"
          :data="stockChart"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <pie-chart
          :donut="true"
          :download="{ background: '#fff' }"
          :colors="['#515815', '#666']"
          :data="gainChart"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      switch1: true,
      report: {},
    };
  },
  computed: {
    barChart() {
      return [
        ["AVL Stock Cost", this.$data.report.costAmount],
        ["AVL Stock Sale Worth", this.$data.report.worthAmount],
        ["Sold Stock Price (Sales)", this.$data.report.salesAmount],
      ];
    },
    stockChart() {
      return [
        ["Sold Items", this.$data.report.sold],
        ["Remaining Items", this.$data.report.quantity],
      ];
    },
    gainChart() {
      return [
        ["Finished Stocks (Sold)", this.$data.report.soldStock],
        ["Running Stocks (Selling)", this.$data.report.unSoldStock],
      ];
    },
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    getFromApi() {
      window.axios.get("/stock-overall").then((response) => {
        this.$data.report = response.data;
      });
    },
  },
};
</script>
